/* ------------------------------------------------------------------ */
/* Seção 5 — Decisões e Pendências                                      */
/* ------------------------------------------------------------------ */
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';

interface Decisao {
  data: string;
  titulo: string;
  descricao: string;
  impacto: string;
}

interface Pendencia {
  prioridade: 'critica' | 'alta' | 'media';
  titulo: string;
  descricao: string;
  desbloqueia: string;
  acao: string;
}

const decisoesResolvidas: Decisao[] = [
  {
    data: '2026-05-27',
    titulo: 'VPS brasileira com ASN brasileiro é obrigatória para RPA',
    descricao:
      'Testado: IP do datacenter americano atual (ASN ReliableSite/US) recebe HTTP 403 "Sorry, you have been blocked" ao acessar eproc1g.tjrs.jus.br. Da máquina residencial: HTTP 200 OK. O Cloudflare do eProc bloqueia IPs de datacenter internacional. Provedores com ASN brasileiro confirmados seguros: Locaweb, KingHost, Magalu Cloud. Hostinger é arriscada (ASN AS47583 internacional). Hostinger deve ser evitada.',
    impacto: 'J05 (eProc adapter) exige VPS brasileira. Será o mesmo host para centralizar bridge DJEN e RPA eProc.',
  },
  {
    data: '2026-05-27',
    titulo: '2FA TOTP obrigatório no eProc — cert não dispensa',
    descricao:
      'Desde abril/2025 (OAB-RS), o eProc exige 2FA TOTP em TODOS os logins, tanto com usuário/senha quanto com certificado digital. Certificado digital NÃO dispensa o 2FA. O "dispositivo confiável" do eProc permite pular o 2FA em um browser/session persistente — estratégia viável para o RPA: manter session persistente após autenticação inicial manual.',
    impacto: 'O adapter J05 precisa gerenciar session persistente do eProc (cookie/token de dispositivo confiável) para evitar 2FA em cada scraping.',
  },
  {
    data: '2026-05-27',
    titulo: 'MNI do eProc é fechado a SaaS privado — confirmado pela documentação oficial',
    descricao:
      'O webservice MNI do eProc (e do PJe) é restrito a órgãos do Judiciário credenciados: Ministério Público, Defensoria Pública, outros tribunais. Escritórios privados e sistemas SaaS não se qualificam. Documentação oficial do CNJ confirma. Marcado como ❌ definitivamente — não há caminho formal.',
    impacto: 'Scraping autenticado é o único caminho viável para J05. Não há plano B via MNI para sistemas privados.',
  },
  {
    data: '2026-05-27',
    titulo: 'Cert em nuvem arquivado para o MVP',
    descricao:
      'Chave no HSM da AC não permite mTLS nem automação server-side sem bridge. Para assinatura: exige parceria comercial cara + 2FA por operação. Para consulta: cert nem é exigido — login/senha basta. Bárbara está sem certificado no ADVBOX e funciona normalmente. A1 server-side > cert nuvem para o MVP.',
    impacto: 'J04 Cert Manager foca em A1 server-side. Cert em nuvem entra na fase de peticionamento avançado, se viável.',
  },
  {
    data: '2026-05-25',
    titulo: 'Res. CNJ 569/2024 unificou COMUNICAÇÕES, não os sistemas',
    descricao:
      'A Resolução CNJ 569/2024 (vigência 16/05/2025) centralizou as comunicações judiciais (intimações, citações) no DJEN. Os sistemas processuais (eProc, PJe, eSAJ) continuam fragmentados por tribunal — a unificação não os afeta. O DJEN é o canal único para receber intimações; o acompanhamento de movimentações e autos ainda exige adapter por sistema.',
    impacto: 'J01 (DJEN) cobre toda a Seção 1. Para autos e movimentações: J05 por sistema ainda é necessário.',
  },
  {
    data: '2026-05-12',
    titulo: 'CDN do CNJ bloqueia IPs de datacenter — DJEN bridge resolveu',
    descricao:
      'O servidor de produção (LXC 107, datacenter americano) recebe HTTP 403 ao acessar o DJEN. Resolvido com bridge Node rodando na máquina local (IP residencial BR) que faz pull do DJEN e push à API via endpoints internos protegidos por X-Internal-Token. Script: tools/djen-bridge/pull-and-push.mjs.',
    impacto: 'Bridge funcional e em produção desde 2026-05-12. Plano: migrar para VPS brasileira junto com RPA eProc.',
  },
  {
    data: '2026-05-11',
    titulo: 'DataJud não está sob o mesmo CDN do DJEN',
    descricao:
      'Testado: LXC 107 (datacenter americano) acessa DataJud normalmente (HTTP 200). DataJud usa infraestrutura separada do DJEN dentro do CNJ, com chave pública anônima sem bloqueio de IP. J02 ativo e funcional em produção sem workaround.',
    impacto: 'J02 funciona do servidor sem bridge. Apenas DJEN e portais de tribunal (eProc) têm o problema de IP.',
  },
];

const pendenciasAbertas: Pendencia[] = [
  {
    prioridade: 'critica',
    titulo: 'Credencial formal de sistema no CNJ (DJEN)',
    descricao: 'Contato: sistemasnacionais@cnj.jus.br. Necessária para polling direto do servidor sem depender de IP residencial.',
    desbloqueia: 'J01 sem bridge local — polling direto do LXC 107 ou da VPS brasileira',
    acao: 'Enviar solicitação ao CNJ com documentação do sistema VoxisAdv. Processo pode levar meses.',
  },
  {
    prioridade: 'critica',
    titulo: 'VPS brasileira com ASN brasileiro',
    descricao: 'Provedores confirmados: Locaweb, KingHost, Magalu Cloud. Será o host do bridge DJEN e do RPA eProc. Evitar Hostinger (ASN internacional).',
    desbloqueia: 'J05 eProc adapter (scraping sem bloqueio Cloudflare) + bridge DJEN 24/7 sem depender de PC local',
    acao: 'Contratar VPS brasileira (512MB RAM, 1 vCPU é suficiente para o RPA). Configurar como segundo servidor de produção.',
  },
  {
    prioridade: 'alta',
    titulo: 'Credenciais eProc da Bárbara para primeiro scraping',
    descricao: 'Necessário: login+senha do eProc, seed TOTP do 2FA, e o PFX/P12 do cert A1 (se disponível). Validação do "dispositivo confiável" para session persistente.',
    desbloqueia: 'J05 adapter TJRS — primeiro scraping real de movimentações',
    acao: 'Solicitar à Bárbara: credenciais do eProc TJRS + seed 2FA. Registrar sessão persistente no VPS BR.',
  },
  {
    prioridade: 'alta',
    titulo: 'TRF5 — verificar sistema correto',
    descricao: 'TRF5 aparece em documentos como PJe. Precisa confirmar se TRF5 usa PJe ou eProc atualmente. Fonte: site oficial do TRF5.',
    desbloqueia: 'Clareza no mapa de tribunais — evitar dados contraditórios',
    acao: 'Verificar no site do TRF5 (trf5.jus.br) qual sistema está em uso atualmente.',
  },
  {
    prioridade: 'media',
    titulo: 'Migrar bridge DJEN para VPS brasileira',
    descricao: 'Após contratar VPS BR: migrar o script tools/djen-bridge/pull-and-push.mjs para rodar como cron 24/7 no novo servidor.',
    desbloqueia: 'Elimina dependência de PC local ligado — DJEN passa a rodar 24/7 de forma confiável',
    acao: 'Configurar cron no VPS BR após contratar. Desligar Task Scheduler Windows após validar.',
  },
  {
    prioridade: 'media',
    titulo: 'Seed adicional de tribunais no J10',
    descricao: 'TRTs regionais menores, TJMs e varas especializadas estão faltando nos 64 tribunais atuais. Campo sistema_processual por tribunal facilitaria o routing do J05.',
    desbloqueia: 'Completude do Tribunal Registry para J05 usar como fonte de verdade',
    acao: 'Adicionar campo sistema_processual na migration, seed TRTs faltantes.',
  },
];

const prioridadeConfig: Record<
  Pendencia['prioridade'],
  { label: string; bg: string; text: string; border: string }
> = {
  critica: {
    label: 'Crítica',
    bg: 'bg-red-500/10',
    text: 'text-red-400',
    border: 'border-red-500/30',
  },
  alta: {
    label: 'Alta',
    bg: 'bg-yellow-500/10',
    text: 'text-yellow-400',
    border: 'border-yellow-500/30',
  },
  media: {
    label: 'Média',
    bg: 'bg-blue-500/10',
    text: 'text-blue-400',
    border: 'border-blue-500/30',
  },
};

export function SecaoDecisoes() {
  return (
    <section aria-label="Decisões e pendências">
      <div className="mb-6 space-y-2">
        <div className="flex items-center gap-2">
          <span className="rounded bg-[var(--surface-muted)] px-2 py-0.5 font-mono text-xs font-bold text-[var(--fg-muted)]">
            SEÇÃO 6
          </span>
          <h2 className="text-xl font-bold tracking-tight">Decisões e Pendências</h2>
        </div>
        <p className="max-w-2xl text-sm text-[var(--fg-muted)] leading-relaxed">
          Decisões técnicas já tomadas (com data e impacto) e pendências abertas que bloqueiam ou condicionam o avanço das integrações.
        </p>
      </div>

      {/* Decisões resolvidas */}
      <div className="mb-8">
        <h3 className="mb-4 text-sm font-semibold uppercase tracking-wide text-green-400">
          Decisões resolvidas
        </h3>
        <div className="space-y-3">
          {decisoesResolvidas.map((d, i) => (
            <Card key={i} className="border-green-500/15">
              <CardHeader className="pb-2">
                <div className="flex items-start gap-3">
                  <span className="mt-0.5 rounded bg-green-500/15 px-2 py-0.5 font-mono text-xs text-green-400 whitespace-nowrap">
                    {d.data}
                  </span>
                  <CardTitle className="text-sm leading-snug">{d.titulo}</CardTitle>
                </div>
              </CardHeader>
              <CardContent className="space-y-2">
                <p className="text-sm text-[var(--fg-muted)] leading-relaxed">{d.descricao}</p>
                <div className="rounded bg-green-500/10 px-3 py-2 text-xs">
                  <span className="font-semibold text-green-400">Impacto: </span>
                  <span className="text-[var(--fg-muted)]">{d.impacto}</span>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>

      {/* Pendências abertas */}
      <div>
        <h3 className="mb-4 text-sm font-semibold uppercase tracking-wide text-yellow-400">
          Pendências abertas
        </h3>
        <div className="space-y-3">
          {pendenciasAbertas.map((p, i) => {
            const cfg = prioridadeConfig[p.prioridade];
            return (
              <Card key={i} className={`border ${cfg.border}`}>
                <CardHeader className="pb-2">
                  <div className="flex items-start justify-between gap-3">
                    <CardTitle className="text-sm leading-snug">{p.titulo}</CardTitle>
                    <span
                      className={`shrink-0 rounded px-2 py-0.5 text-xs font-semibold ${cfg.bg} ${cfg.text}`}
                    >
                      {cfg.label}
                    </span>
                  </div>
                </CardHeader>
                <CardContent className="space-y-2">
                  <p className="text-sm text-[var(--fg-muted)] leading-relaxed">{p.descricao}</p>
                  <div className="grid gap-2 sm:grid-cols-2">
                    <div className="rounded bg-[var(--surface-muted)]/60 px-3 py-2 text-xs">
                      <span className="font-semibold text-[var(--fg-muted)]">Desbloqueia: </span>
                      <span className="text-[var(--fg-muted)]">{p.desbloqueia}</span>
                    </div>
                    <div className="rounded bg-[var(--surface-muted)]/60 px-3 py-2 text-xs">
                      <span className="font-semibold text-[var(--fg-muted)]">Ação: </span>
                      <span className="text-[var(--fg-muted)]">{p.acao}</span>
                    </div>
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
}
